/** @jsxImportSource @emotion/react */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { default_theme as theme } from '../emotion/theme'
import { jsx, css } from '@emotion/react'
import { head, get } from 'lodash'
import { Link } from 'react-router-dom'
import { CardHeader } from './layout/CardHeader'
import { Trans, Translation } from 'react-i18next'
import BusyMask from './BusyMask'
import CurrencyValue from './CurrencyValue'
import Timestamp from './Timestamp'
import { subscriptionTransactionList, creditsTransactionList } from '../actions/transaction'
import Card from './layout/Card'
import CardInfoText from './layout/CardInfoText'
import CardH2Text from './layout/CardH2Text'
import CommonTable from './CommonTable'
import { InlineIcon } from './layout/InlineIcon'
import { WhiteButton } from './layout/WhiteButton'
import MainLayout from './MainLayout'
import QuickLinksCard from './QuickLinksCard'
import CreditInformationCard from './CreditInformationCard'
import { Row, Col, Container } from 'react-bootstrap'
import { Separator } from './layout/Separator'
import { DatePicker } from './form/DatetimePicker'
import TableFilter from './layout/TableFilter'
import { Button } from 'react-bootstrap'
import { aggregatedTransactions } from '../actions/aggregated_transactions'
import { TransactionsTable } from './TransactionsTable'

class Transactions extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        const { dispatch } = this.props

        dispatch(subscriptionTransactionList.updateListFilter({relates_to_account:"subscriptions"}))
        dispatch(creditsTransactionList.updateListFilter({relates_to_account:"credits"}))
        dispatch(subscriptionTransactionList.fetchListIfNeeded())
        dispatch(creditsTransactionList.fetchListIfNeeded())
    }

    componentDidUpdate(prev_props) {
        const { dispatch } = this.props
        dispatch(subscriptionTransactionList.fetchListIfNeeded())
        dispatch(creditsTransactionList.fetchListIfNeeded())
    }

    onFilterChanged = (filter_values) => {
        const { dispatch } = this.props
        dispatch(subscriptionTransactionList.updateListFilter(filter_values))
        dispatch(creditsTransactionList.fetchListIfNeeded())
    }

    onDateFromChanged = (value) => {
        const { dispatch } = this.props
        dispatch(subscriptionTransactionList.updateListFilter({ executed_at_from: value.format() }))
        dispatch(creditsTransactionList.updateListFilter({ executed_at_from: value.format() }))
    }

    onDateToChanged = (value) => {
        const { dispatch } = this.props
        dispatch(subscriptionTransactionList.updateListFilter({ executed_at_to: value.format() }))
        dispatch(creditsTransactionList.updateListFilter({ executed_at_to: value.format() }))
    }

    getFilterForRender() {
        const { customer_id, customer } = this.props
        const that = this

        const filter = (
            <Translation>
              {(t) => (
                  <div css={header_right_child}>
                    <DatePicker
                        onChange={this.onDateFromChanged}
                        placeholder={t('From date')}
                    />

                    <DatePicker
                        onChange={this.onDateToChanged}
                        placeholder={t('To date')}
                    />

                    <TableFilter
                        label=""
                        placeholder={t('Search')}
                        updateOnChange={this.onFilterChanged}
                    />
                    <Separator variant="w20" />
                    <WhiteButton onClick={this.onDownload} auto_disable={false}>
                      <div css={download_button_style}>
                        <InlineIcon icon_name="download" onClick={that.onDownload} />
                        <Separator variant="w5" />
                        Excel
                      </div>
                    </WhiteButton>
                  </div>
              )}
            </Translation>
        )

        return filter
    }

    render() {
        const { is_loading, headers, transactions } = this.props
        const filter = this.getFilterForRender()
        return (
            <MainLayout
                active_key="transactions"
                enable_breadlinks={true}
                breadcrumbs={[
                    { name: 'home' },
                    { name: 'transactions', label: Transactions, url: '/transactions' },
                ]}
            >
              <Container fluid>
                <Separator variant="h20" />

                <Row>
                  <Col md={9}>
                    <CardHeader title={<Trans>Credit history</Trans>} right_child={filter} />
                    <TransactionsTable transactionList={creditsTransactionList} showBalance={true} showingCreditsPerspective={true}/>

                    { false &&
                      <>
                        <Separator variant="h40" />

                        <CardHeader title=<Trans>Subscription history</Trans> right_child={filter} />
                          <TransactionsTable transactionList={subscriptionTransactionList} showBalance={false} showingCreditsPerspective={false}/>
                      </>
                    }
                    
                  </Col>
                  <Col md={3}>
                    <Row>
                      <Col>
                        <CreditInformationCard show_quick_links={false} />
                      </Col>
                    </Row>
                    <Separator variant="h40" />
                  </Col>
                </Row>
              </Container>
            </MainLayout>
        )
    }
}

function mapStateToProps(state, props) {
    return {
        filter: subscriptionTransactionList.getFilter(),
    }
}

export default connect(mapStateToProps)(Transactions)

const transaction_modal_currency_value_row_style = css`
    display: flex;
`

const header_right_child = css`
    display: flex;
    align-items: center;
`

const download_button_style = css`
    display: flex;
    justify-content: space-between;
`

const total_amounts_container_style = css``

const description_sub_field_style = css`
    color: ${theme.colors.grey};
`
